import React, { useState } from "react";
import { Calculator, Car, ChevronDown, ChevronUp, Globe, Layers, Save } from "lucide-react";

export default function DkGelismisModulGiris() {
    const [acik, setAcik] = useState(false);

    return (
        <div className="rounded-2xl border border-white/10 bg-[#0c1222]/60 overflow-hidden">
            <button
                type="button"
                onClick={() => setAcik((v) => !v)}
                className="w-full flex items-center justify-between px-5 py-3 text-left hover:bg-white/[0.02]"
            >
                <span className="text-sm text-slate-400">Modül rehberi & formül</span>
                {acik ? <ChevronUp className="h-4 w-4" /> : <ChevronDown className="h-4 w-4" />}
            </button>
            {acik ? (
                <div className="px-5 pb-5 pt-0 text-sm text-slate-400 space-y-3 border-t border-white/5">
                    <p>
                        <Layers className="inline h-4 w-4 text-[#D4AF37] mr-1" />
                        <strong className="text-slate-200">NET DK</strong> = (Rayiç × %19) × KM × Hasar katsayısı ×
                        Kusur. Hasar katsayısı araç görselinde seçilen her parçanın işlem tipine göre toplanır (tavan %90).
                    </p>
                    <ul className="grid sm:grid-cols-2 gap-2 text-xs">
                        <li className="flex gap-2">
                            <Car className="h-4 w-4 text-emerald-400 shrink-0" />
                            Gerçek araç fotoğrafı üzerinde parça seçin
                        </li>
                        <li className="flex gap-2">
                            <Globe className="h-4 w-4 text-violet-400 shrink-0" />
                            Piyasa rayiç medyan/ortalama
                        </li>
                        <li className="flex gap-2">
                            <Calculator className="h-4 w-4 text-emerald-400 shrink-0" />
                            Hesap zinciri ve üst sınırlar (fatura %85, rayiç %50)
                        </li>
                        <li className="flex gap-2">
                            <Save className="h-4 w-4 text-[#D4AF37] shrink-0" />
                            Onaylı dosya kaydı
                        </li>
                    </ul>
                </div>
            ) : null}
        </div>
    );
}
